const translations = {
    address: 'Address: ',
    boundary: 'Boundary: ',
    coordinates: 'Lat, Long: ',
    name: 'Site Name: '
};

export default translations;
